export default __webpack_public_path__ + "static/media/mago_overlap.7952de24.mp3";